import React from 'react';
import { Container } from '@mui/material';
import { AuditionWrapper, IAuditionWrapper } from '../../AuditionComponents/AuditionWrapper';

interface IAuditionContainerProps extends IAuditionWrapper {}

const AuditionContainer: React.FC<IAuditionContainerProps> = props => {
    return (
        <Container
            disableGutters
            maxWidth={false}
            style={{
                height: 'auto',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                // overflow: 'hidden',
            }}
            sx={{
                width: '100%',
                marginTop: 0,
                marginLeft: 0,
                marginRight: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                overflowX: 'hidden',
            }}>
            <AuditionWrapper {...props} />
        </Container>
    );
};

export { AuditionContainer };
